<!-- Created by henian.xu on 2018/7/20. -->

<template>
    <page>
        <!-- 表单区 -->
        <template slot="secondHeader">
            <el-tabs
                class="classify-tabs"
                v-model="queryFormModel.invoiceStatus"
                type="card"
                @tab-click="onQuery()"
            >
                <el-tab-pane
                    label="待开票"
                    name="10"
                />
                <el-tab-pane
                    label="开票成功"
                    name="100"
                />
                <el-tab-pane
                    label="开票失败"
                    name="90"
                />
            </el-tabs>
            <el-form
                ref="queryForm"
                class="second-header npa-b"
                size="small"
                :inline="true"
                :model="queryFormModel"
            >
                <el-form-item
                    prop="mobile"
                    label="开票人手机号"
                >
                    <el-input
                        v-model="queryFormModel.mobile"
                        placeholder="请输入开票人手机号"
                    />
                </el-form-item>
                <el-form-item
                    prop="invoiceTitle"
                    label="发票抬头"
                >
                    <el-input
                        v-model="queryFormModel.invoiceTitle"
                        placeholder="请输入发票抬头"
                    />
                </el-form-item>
                <el-form-item
                    prop="invoiceTime"
                    label="开票时间"
                >
                    <el-date-picker
                        :picker-options="$utils.CommonConfig.pickerOptions"
                        v-model="queryFormModel.invoiceTime"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="onQuery()"
                    >
                        查询
                    </el-button>
                    <el-button
                        type="success"
                        @click="onReset"
                    >
                        重置
                    </el-button>
                </el-form-item>
            </el-form>
        </template>

        <!-- 内容 -->
        <div
            class="body"
            slot="body"
            v-loading="querying"
        >
            <!-- 表格 -->
            <el-table
                stripe
                border
                size="small"
                :data="tableData"
                style="width: 100%"
            >
                <el-table-column
                    prop="mobile"
                    label="开票人手机号"
                    min-width="100"
                />
                <el-table-column
                    prop="invoiceTypeName"
                    label="发票类型"
                    min-width="100"
                />
                <el-table-column
                    prop="invoiceTitleTypeName"
                    label="发票抬头类型"
                    min-width="100"
                />
                <el-table-column
                    prop="invoiceTitle"
                    label="发票抬头"
                    min-width="100"
                />
                <el-table-column
                    prop="invoiceAmount"
                    label="开票金额"
                    min-width="100"
                />
                <el-table-column
                    label="开票时间"
                    min-width="150"
                >
                    <template slot-scope="scope">
                        {{ scope.row.invoiceTime | moment('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    width="90"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="$router.push('/order/invoice/orderInvoice/detail/' + scope.row.id )"
                        >
                            {{ scope.row.invoiceStatus == 10 ? '审核' : '查看' }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="ma-t ta-r">
                <pagination
                    v-model="pagination"
                    @input="onQuery"
                />
            </div>
        </div>
    </page>
</template>

<script>
import pagesMixin from '@/mixin/layout/pageMixin';
import { queryFormList } from 'vmf/src/mixins';

export default {
    name: 'OrderInvoice',
    mixins: [pagesMixin, queryFormList],
    data() {
        return {
            queryFormModel: {
                invoiceTitle: '', // 发票抬头
                mobile: '',
                invoiceTime: '',
                invoiceStatus: '10',
            },
            // 表格数据
            tableData: [],
        };
    },
    methods: {
        /* -- 方法 -- */
        // 请求列表数据
        getListData(queryData) {
            return this.$api.Ex.OrderInvoice.data(queryData).then(json => {
                const res = json.data;
                this.tableData = res.data;
                this.pagination = res.pagination;
                return Promise.resolve(json);
            });
        },
    },
};
</script>

<style lang="scss">
</style>
